import { Route } from 'react-router-dom';
import { home } from 'routes/config';

import Performance from 'containers/Business/Agent/Performance';

export const performanceRoutes = <Route path={home.performance} element={<Performance />} />;
